import { useContext, ReactNode } from 'react'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { IAuthState } from '../auth'
import { ActiveMenuContex } from 'src/cms/layout/MasterLayout'
interface Props {
  type: string
  children: ReactNode
}

const CheckPermissions = ({ type, children }: Props) => {
  const auth: IAuthState = useSelector((state: any) => state.auth)
  const activeMenu: any = useContext(ActiveMenuContex)
    const Authtype: string = useSelector((state: any) => state.auth?.rolePermissions?.permissions.some(
    (permission: any) => permission?.name===`${type} ${activeMenu?.currentActiveMenu}`
    ))
    

  const hasPermission = auth?.rolePermissions?.permissions.find(
    (permission) => permission?.name === `${type} ${activeMenu?.currentActiveMenu}`
        // (permission) => permission?.name === `${type} User`

  )
  // console.log(activeMenu,auth?.rolePermissions?.permissions,'rujal')
  // console.log('hasPermission',hasPermission,type,auth?.rolePermissions?.permissions.filter(
  //   (permission) => permission?.name
  // ),`${type} ${activeMenu?.currentActiveMenu}`,Authtype);
  return <>{(Authtype) && children}</>
  // return <>{!isEmpty(Authtype) ? children : null}</>
}

export default CheckPermissions
